import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function ActionByPlayer() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [playerType, setPlayerType] = useState(0);
  const onPlayerTypeChange = useCallback(
    (event) => setPlayerType(Number(event.target.value)),
    []
  );

  const [groupByAgent, setGroupByAgent] = useState(false);
  const onGroupByAgentChange = useCallback(
    (event) => setGroupByAgent(event.target.checked),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          className="flex-1"
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <div>
          <SubGroup title="Player Type">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={playerType}
                onChange={onPlayerTypeChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Both"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Cash"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Credit"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
        <div className="col-span-2">
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={groupByAgent}
                onChange={onGroupByAgentChange}
                color="primary"
              />
            }
            label="Group by Agent"
          />
        </div>
      </div>
      <Report
        groupBy={groupByAgent ? "agent" : null}
        title="Action by Player Report"
        getUrl={() => "/Reports/Report_Action_By_Player_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Office: office,
          Group: group,
          Book: book,
          Distributor: distributor,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          LineType: lineType,
          PlayerType: playerType,
          GroupbyAgent: groupByAgent,
        })}
        getTotals={(data) => ({
          player: groupByAgent
            ? `Sub Total ${data.length} Players`
            : `Total ${data.length} Players`,
          name: "",
          straight: data.reduce((acc, curr) => acc + curr.straight, 0),
          parlay: data.reduce((acc, curr) => acc + curr.parlay, 0),
          teaser: data.reduce((acc, curr) => acc + curr.teaser, 0),
          reverses: data.reduce((acc, curr) => acc + curr.reverses, 0),
          horses: data.reduce((acc, curr) => acc + curr.horses, 0),
          others: data.reduce((acc, curr) => acc + curr.others, 0),
          adj: data.reduce((acc, curr) => acc + curr.adj, 0),
          horseAdj: data.reduce((acc, curr) => acc + curr.horseAdj, 0),
          casino: data.reduce((acc, curr) => acc + curr.casino, 0),
          total: data.reduce((acc, curr) => acc + curr.total, 0),
        })}
        getGlobalTotals={(data) => ({
          player: `Total ${data.length} Players`,
          name: "",
          straight: data.reduce((acc, curr) => acc + curr.straight, 0),
          parlay: data.reduce((acc, curr) => acc + curr.parlay, 0),
          teaser: data.reduce((acc, curr) => acc + curr.teaser, 0),
          reverses: data.reduce((acc, curr) => acc + curr.reverses, 0),
          horses: data.reduce((acc, curr) => acc + curr.horses, 0),
          others: data.reduce((acc, curr) => acc + curr.others, 0),
          adj: data.reduce((acc, curr) => acc + curr.adj, 0),
          horseAdj: data.reduce((acc, curr) => acc + curr.horseAdj, 0),
          casino: data.reduce((acc, curr) => acc + curr.casino, 0),
          total: data.reduce((acc, curr) => acc + curr.total, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="password">
          Password
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="name">
          Name
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="straight"
          dataFormat={decimalInvertedReportFormatter}
        >
          Straight
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="parlay"
          dataFormat={decimalInvertedReportFormatter}
        >
          Parlay
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="teaser"
          dataFormat={decimalInvertedReportFormatter}
        >
          Teaser
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="reverses"
          dataFormat={decimalInvertedReportFormatter}
        >
          Reverse
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="casino"
          dataFormat={decimalInvertedReportFormatter}
        >
          Casino
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="horses"
          dataFormat={decimalInvertedReportFormatter}
        >
          Horse
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="others"
          dataFormat={decimalInvertedReportFormatter}
        >
          Others
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="adj"
          dataFormat={decimalInvertedReportFormatter}
        >
          Others Adj
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="horseAdj"
          dataFormat={decimalInvertedReportFormatter}
        >
          Horse Adj
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="total"
          dataFormat={decimalInvertedReportFormatter}
        >
          Total
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default ActionByPlayer;
